/**
 * useIsNarrow Hook
 * Detects if the screen width is narrow (≤768px) for responsive behavior
 * Matches ReactRoot's tabletMaxWidth threshold
 */

import { useEffect, useState } from 'react';

/**
 * Threshold for narrow screens in pixels
 * Matches sassVars.tabletMaxWidth from ReactRoot
 */
const NARROW_SCREEN_THRESHOLD = 768;

/**
 * Hook to detect if the current screen is narrow
 * @returns boolean indicating if screen width is ≤768px
 */
export const useIsNarrow = (): boolean => {
  const [isNarrow, setIsNarrow] = useState(
    () => window.innerWidth <= NARROW_SCREEN_THRESHOLD,
  );

  useEffect(() => {
    const handleResize = () => {
      setIsNarrow(window.innerWidth <= NARROW_SCREEN_THRESHOLD);
    };

    // Add event listener
    window.addEventListener('resize', handleResize);

    // Call handler immediately to set initial state
    handleResize();

    // Cleanup
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return isNarrow;
};

export default useIsNarrow;

